import React, { useRef, useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { useGlobalContext } from '@/context/GlobalContext';
import { ArrowUpRight } from 'lucide-react';

// import { ChevrondownSvg, RightArrowBlackIcon } from "@/src/Asset";

const ExploreCoursesByStream = ({ streamData }: any) => {
  const { setIsLeadFormOpen, setLeadFormData } = useGlobalContext();
  const [visibleStreams, setVisibleStreams] = useState(8);
  const streamsRef = useRef<HTMLDivElement>(null);

  const filteredStreams = streamData?.filter((stream: any) => stream?.courses?.length > 0);

  const loadMoreStreams = () => setVisibleStreams((prev) => prev + 8);

  const loadLessStreams = () => {
    setVisibleStreams(8);
    streamsRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleOpen = (title: string) => {
    setLeadFormData({ source: `coursePage`, title: title ?? null });
    setIsLeadFormOpen(true);
    console.log('open lead form');
  };

  const renderCourses = (stream: any, additionalClasses = '') => (
    <div className={`flex flex-wrap gap-1 text-sm text-gray-700 ${additionalClasses}`}>
      {stream?.courses
        ?.filter((course: any) => course?.page_data?.length > 0)
        ?.slice(0, 7)
        ?.map((course: any, index: number, filteredCourses: any) => {
          const navbars = course?.course_navbars;
          return (
            <Link
              href={`/courses/${course?.course_url}/${navbars[0]?.title.replace(/\s+/g, '-').toLowerCase()}`}
              key={course?.id}
              className={`text-xs md:text-sm ${
                index < filteredCourses.length - 1 ? 'after:mx-2 after:content-["|"]' : ''
              }`}
            >
              {course?.abbreviation ?? course?.course_name}
            </Link>
          );
        })}
    </div>
  );

  return (
    <div className="my-5 w-full px-4 font-sans lg:mx-auto lg:my-10 lg:w-4/5 lg:max-w-screen-xl" ref={streamsRef}>
      <div className="w-full text-center text-xl font-semibold leading-tight tracking-tight md:text-2xl xl:text-3xl">
        <span className="text-primary">Choose by Streams</span>
      </div>
      <p className="mx-auto mt-2 text-center text-xs text-primary-gray lg:w-3/5 lg:text-base">
        Explore courses across various fields. Whether it&apos;s Engineering, Arts, Business, or more, find programs
        suited to your interests and goals.
      </p>

      <div className="mt-8 w-full overflow-hidden rounded-lg border shadow-md">
        <div className="grid grid-cols-4 gap-x-8 border-b bg-primary-blue/20 py-4 text-center font-inter text-sm font-semibold uppercase tracking-wide text-[#6E6893]">
          <div className="hidden lg:block">Stream</div>
          <div className="col-span-2 hidden text-left lg:block">Courses</div>
          <div className="col-span-3 px-2 text-start md:hidden">Choose By Stream</div>
        </div>
        {filteredStreams?.slice(0, visibleStreams)?.map((stream: any) => (
          <React.Fragment key={stream.id}>
            <div className="grid grid-cols-4 items-center gap-x-4 px-1 py-2 font-inter sm:px-4 lg:border-b">
              <div className="col-span-2 flex items-center gap-x-3 lg:col-span-1">
                {stream?.icon && (
                  <div className="flex size-10 items-center justify-center rounded-full border bg-primary-light-gray text-center lg:size-12">
                    <Image
                      src={stream?.icon.url}
                      alt={stream?.stream_name ?? 'Stream'}
                      width={80}
                      height={80}
                      className="size-10 object-center p-1 lg:size-12"
                    />
                  </div>
                )}
                <span className="text-sm font-medium text-primary-text lg:text-base">{stream?.stream_name}</span>
              </div>
              <div className="col-span-2 hidden lg:flex">{renderCourses(stream)}</div>
              <div className="col-span-2 flex w-full flex-col items-end justify-end gap-2 lg:col-span-1 lg:flex-row lg:items-center lg:gap-4">
                <Link
                  href={`/courses/${stream?.stream_name?.replace(/\s+/g, '-')?.toLowerCase()}`}
                  className="flex w-fit max-w-36 items-center rounded border border-primary bg-primary-blue/25 px-4 py-0.5 text-center text-xs font-medium text-primary-blue hover:scale-105 lg:w-full lg:py-1 lg:text-sm"
                >
                  View <span className="hidden pl-0.5 lg:inline-block">Courses</span>{' '}
                  <ArrowUpRight size={16} className='ml-2 text-primary-blue'/>
                </Link>
                <button
                  className="w-fit max-w-32 rounded border border-primary-blue bg-primary px-6 py-1 text-center text-xs text-white hover:scale-105 lg:text-sm"
                  onClick={() => handleOpen(stream?.stream_name)}
                >
                  Apply
                </button>
              </div>
            </div>
            <div className="col-span-2 mb-1 flex border-b px-2 pb-2 text-xs text-gray-700 lg:hidden">
              {renderCourses(stream)}
            </div>
          </React.Fragment>
        ))}
        {filteredStreams?.length > 8 && (
          <div className="my-4 text-center">
            {visibleStreams < filteredStreams?.length ? (
              <button onClick={loadMoreStreams} className="font-medium text-blue-600">
                View More
                {/* <ChevrondownSvg className="inline-block" /> */}
              </button>
            ) : (
              <button onClick={loadLessStreams} className="font-medium text-blue-600">
                View Less
                {/* <ChevrondownSvg className="inline-block rotate-180" /> */}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ExploreCoursesByStream;
